import { render, staticRenderFns } from "./cardAttachments.vue?vue&type=template&id=3ff77706&scoped=true&"
import script from "./cardAttachments.vue?vue&type=script&lang=js&"
export * from "./cardAttachments.vue?vue&type=script&lang=js&"
import style0 from "./cardAttachments.vue?vue&type=style&index=0&id=3ff77706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff77706",
  null
  
)

component.options.__file = "cardAttachments.vue"
export default component.exports